import { render, staticRenderFns } from "./UpdateOrderCaution.vue?vue&type=template&id=31824fd6&"
import script from "./UpdateOrderCaution.vue?vue&type=script&lang=js&"
export * from "./UpdateOrderCaution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports